import { H6 } from '@blueprintjs/core';
import styles from './ApplicationDataApplicantTabPanelLayout.module.css';

export const ApplicantDataApplicantTabPanelLayout: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  return <div className={styles.mainLayoutGrid}>{children}</div>;
};

type ApplicantDataApplicantTabPanelSectionProps = React.PropsWithChildren<{
  title: string;
}>;

export const ApplicantDataApplicantTabPanelSection: React.FC<
  ApplicantDataApplicantTabPanelSectionProps
> = ({ title, children }) => {
  return (
    <div className={styles.section}>
      <H6 className={styles.header}>{title}</H6>
      {children}
    </div>
  );
};
